export default "__VITE_ASSET__456f6ab0__"